import { Alert, Col, DatePicker, Form, List, Row, message } from 'antd';
import moment from 'moment';
import React, { useEffect } from 'react';
import { getDocumentDetail, requestApproval, updateApproval } from 'services/session';
import { OwnDesktops, RequestInfo, UserSearchInput } from './components';
import { getErrorFields } from '../utils';

function DesktopReinstall({ readOnly, form, id, onClose }) {
  const [user, setUser] = React.useState('');
  const [selectedVd, setSelectedVd] = React.useState([]);
  const [userName, setUserName] = React.useState('');

  useEffect(() => {
    if (!id) {
      form.resetFields();
      setUser('');

      const applicant = localStorage.getItem('userId');
      form.setFieldsValue({
        applicant,
        type: 'approval.types.reset-vd',
      });
      return;
    }

    getDocumentDetail(id).then((data) => {
      let approveDate = data?.approveDate;

      if (approveDate !== null) {
        approveDate = moment(approveDate);
      }

      form.setFieldsValue({
        ...data,
        approveDate,
        applyDate: moment(data.applyDate).format('YYYY-MM-DD HH:mm:ss'),
      });
      setUser(data?.user);
      setUserName(data?.userName);
    });
  }, [id]);

  return (
    <Form
      form={form}
      layout="horizontal"
      labelCol={{ span: 5 }}
      wrapperCol={{ span: 19 }}
      onFinish={async ({ approveDate, ...fields }) => {
        const payload = {
          ...fields,
          contents: JSON.stringify(selectedVd),
          approveDate: approveDate?.format('YYYY-MM-DD HH:mm'),
        };
        try {
          const result = id ? await updateApproval(id, payload) : await requestApproval(payload);
          if (result.data.status === 'error') {
            const errors = getErrorFields(result.data.invalidParams);
            form.setFields(errors);
            return;
          }
          form.resetFields();
          onClose();
        } catch (e) {
          message.error(e);
        }
      }}
    >
      <Row gutter={[0, 24]}>
        <Col span={24}>
          <Alert
            showIcon
            type="warning"
            message={
              <List
                size="small"
                split={false}
                dataSource={[
                  'OS 재설치로 인해 C:의 모든 데이터가 삭제됩니다. 데이터 백업 후 신청하시고 개인의 필요 S/W는 재설치해야 합니다.',
                ]}
                renderItem={(item) => <List.Item style={{ padding: 4 }}>{item}</List.Item>}
              />
            }
          />
        </Col>
        <Col span={24}>
          <RequestInfo readOnly={readOnly} />
          <Form.Item label="신청 종류" name="type" required>
            VD 초기화
          </Form.Item>
          <Form.Item
            label="사용자(ID)"
            name="user"
            rules={[{ required: true, message: '필수 입력 항목 입니다.' }]}
          >
            <UserSearchInput
              readOnly1={readOnly}
              onSuccess={async (uid) => {
                // 처리
                setUser(uid);
              }}
              userName={userName}
            />
          </Form.Item>
          <Form.Item label="재설치 Desktop" name="contents" valuePropName="contents" required>
            <OwnDesktops
              title={false}
              bodyStyle={{ padding: 0 }}
              user={user}
              readOnly={readOnly}
              onSelect={(record) => {
                setSelectedVd(record);
              }}
              id={id}
            />
          </Form.Item>
          <Form.Item
            label="작업 희망 일시"
            name="approveDate"
            extra="작업 희망 일시를 설정하지 않거나 이미 경과된 경우 승인 시점에 처리됩니다."
            rules={[
              () => ({
                validator(_, value) {
                  if (value > moment() || !value) {
                    return Promise.resolve();
                  }
                  return Promise.reject(new Error('현재보다 이전 시간은 설정할 수 없습니다.'));
                },
              }),
            ]}
          >
            <DatePicker
              showTime={{
                defaultValue: moment('00:00', 'HH:mm'),
                format: 'HH:mm',
              }}
              inputReadOnly={1}
              disabled={readOnly}
              placeholder=""
              disabledDate={(current) => current && current < moment().add(-1, 'day')}
              showNow={false}
            />
          </Form.Item>
        </Col>
      </Row>
    </Form>
  );
}

export default DesktopReinstall;
